export const startVisibleInterval = (update: () => void, delay: number) => {
  let interval: number | undefined;

  const syncVisibility = () => {
    window.clearInterval(interval);
    interval = undefined;
    if (document.hidden) return;
    update();
    interval = window.setInterval(update, delay);
  };

  document.addEventListener("visibilitychange", syncVisibility);
  syncVisibility();

  return () => {
    window.clearInterval(interval);
    document.removeEventListener("visibilitychange", syncVisibility);
  };
};
